import angular from 'angular';

import deploymentFrequency from './deployment-frequency';
import summary from './summary';
import leadTime from './lead-time';
import changeVolume from './change-volume';
import activity from './activity';
import WidgetsHelper from './widgets-helper.service';
export default angular.module('dbm.dashboard.components.widgets', [
    deploymentFrequency,
    leadTime,
    changeVolume,
    summary,
    activity
])
.service('widgetsHelper', WidgetsHelper)
.name;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/widgets/index.js